const STAMP_PATTERN = /-(?:draft|signed)-(\d{8}-\d{6})\.pdf$/

export const buildSignedPdfPath = (metadataEntryId: string, stamp: string) =>
  `reportPDFSigned/report-${metadataEntryId}-signed-${stamp}.pdf`

export const parsePdfStamp = (path: string) => path.match(STAMP_PATTERN)?.[1]

/** Newest stamped file; unstamped files are ignored. */
export function pickLatestStamped<T extends { path: string }>(
  refs: readonly T[]
): { ref: T; stamp: string } | undefined {
  let latest: { ref: T; stamp: string } | undefined
  for (const ref of refs) {
    const stamp = parsePdfStamp(ref.path)
    if (stamp && (!latest || stamp > latest.stamp)) latest = { ref, stamp }
  }
  return latest
}
